Application.QrCode.Color = {
    ui: {
        container: '.js-qr-code-color',
        previewContent: '.js-qr-code-color__preview'
    },
    previewList: null,
    ready: function (previewList) {

        if (!$(this.ui.container).length){
            return;
        }

        // assign
        this.previewList = previewList;

        // bind handlers
        this.bind();

    },
    bind: function(){

        var self = this;

        // update color when requested
        this.previewList.setOnChange(function(id, src, data){
            self.preview(id, src);
        });

    },
    preview: function(id, src){

        var self = this;

        // load the image
        $('<img/>').attr('src', src).on('load', function() {
            // prevent memory leaks
            $(this).remove();
            // change background
            $(self.ui.previewContent).css('background-image', 'url(' + src + ')');
            // loaded callback
            if (typeof onloaded == 'function') {
                onloaded();
            }
        });

    }
};